import { PlusCircleSVG } from 'common/assets';
import { Button } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import { SeparatorHorizontal, SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import CruiseCard from './cruise-card';
import GuestCard from './guest-card';
import { CruiseSaleFormType } from '../form-type';
import { addNewCruiseSaleItem } from '../hooks/use-get-default-values';

export default function CruiseSection() {
  const { t } = useTranslation();
  const { editable } = useFormState();
  const { control, getValues } = useFormContext<CruiseSaleFormType>();

  const fields = getValues('cruiseSales');
  const { append, remove } = useFieldArray({
    control,
    name: 'cruiseSales',
    keyName: '__customId',
  });

  const onAddCruiseSale = React.useCallback(() => {
    append({
      ...addNewCruiseSaleItem(),
      bookingCode: fields[0].bookingCode,
      cruiseId: fields[0].cruiseId,
      cruiseName: fields[0].cruiseName,
      cruiseShipId: fields[0].cruiseShipId,
      cruiseShipName: fields[0].cruiseShipName,
      reminder: fields[0].reminder,
      reminderDate: fields[0].reminderDate,
      reminderDescription: fields[0].reminderDescription,
      route: fields[0].route,
      endedAt: fields[0].endedAt,
      startedAt: fields[0].startedAt,
    });
  }, [append, fields]);

  const onRemoveCruiseSale = React.useCallback(
    (index) => {
      remove(index);
    },
    [remove],
  );

  return (
    <div>
      <CruiseCard parentIndex={0} />
      <SeparatorVertical $margin={22}>
        <div style={{ height: 2 }} />
      </SeparatorVertical>

      {fields.map((field, index) => (
        <React.Fragment key={field.customId}>
          <GuestCard
            parentIndex={index}
            onRemove={() => onRemoveCruiseSale(index)}
            fieldLength={fields.length}
          />
          <SeparatorVertical $margin={22}>
            <div style={{ height: 2 }} />
          </SeparatorVertical>
        </React.Fragment>
      ))}
      {editable && (
        <>
          <SeparatorHorizontal $margin={16} />
          <Button
            startEnhancer={(color, size) => (
              <PlusCircleSVG color={color} size={size} />
            )}
            buttonType="secondary"
            onClick={onAddCruiseSale}
          >
            {t('common:add')}
          </Button>
        </>
      )}
    </div>
  );
}
